import { render, staticRenderFns } from "./CommonFlow.vue?vue&type=template&id=60132685&scoped=true"
import script from "./CommonFlow.vue?vue&type=script&lang=js"
export * from "./CommonFlow.vue?vue&type=script&lang=js"
import style0 from "./CommonFlow.vue?vue&type=style&index=0&id=60132685&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60132685",
  null
  
)

export default component.exports